import React, { useState,useEffect,useCallback } from "react";
import { Container, TextField, MenuItem, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Typography,Grid,Pagination } from "@mui/material";
import axios from "axios";
import BASE_URL from "../config";
const PromotePage = () => {
   const [courses, setCourses] = useState([]);
     const [academicYears, setAcademicYears] = useState([]);
     const [classes, setClasses] = useState([]);
     const [selectedCourse, setSelectedCourse] = useState("");
     const [selectedYear, setSelectedYear] = useState("");
     const [selectedClass, setSelectedClass] = useState("");
      const [searchText, setSearchText] = useState("");
    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
    //const [alertMessage, setAlertMessage] = useState("");
// Fetch courses
  useEffect(() => {
    axios.get(`${BASE_URL}/api/coursesa`).then((res) => setCourses(res.data));
  }, []);

  // Fetch academic years and classes when course changes
  useEffect(() => {
    if (selectedCourse) {
      axios.get(`${BASE_URL}/api/academicYears/${selectedCourse}`).then((res) => setAcademicYears(res.data));
      axios.get(`${BASE_URL}/api/classes/${selectedCourse}`).then((res) => setClasses(res.data));
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  }, [selectedCourse]);
  // Fetch students when search filters change
   useEffect(() => {
     if (selectedCourse || selectedYear || selectedClass || searchText) {
       handleSearch();
     }
   }, [page]); // Runs when page changes
    const handleSearch =  () => {
       /*  if (!courses || !academicYears || !classes) {
            setAlertMessage("Please select Course, Academic Year, and Class.");
            return;
        } */
            if (!selectedCourse || !selectedYear || !selectedClass) {
                alert("Please select Course, Academic Year, and Class before searching.");
                return;
              }
        //setAlertMessage("");
        try {
            /* const response = await axios.get(`${BASE_URL}/api/students`, { params: { courses, academicYears, classes } });
            setStudents(response.data); */
            axios
                  .get(
                    `${BASE_URL}/api/students?courseId=${selectedCourse}&yearId=${selectedYear}&classId=${selectedClass}&search=${searchText}&page=${page}`
                  )
                  .then((res) => {
                    setStudents(res.data.students);
                    setTotalPages(res.data.totalPages);
                  })
                  .catch((err) => console.error("Error fetching students:", err));
        } catch (error) {
            console.error("Error fetching students", error);
        }
    /* }, [selectedCourse, selectedYear, selectedClass, searchText, page]); */
    };
 
   /*  const handlePromote = async (student) => {
        try {
            const balanceResponse = await axios.get(`${BASE_URL}/api/check-balance`, { params: { studentID: student.StudentID } });
            if (balanceResponse.data.balance > 0) {
                setAlertMessage(`Fee balance: ${balanceResponse.data.balance} for ${student.StudentName}`);
                return;
            }
            await axios.post("/api/promote", { studentID: student.StudentID });
            setAlertMessage(`${student.StudentName} promoted successfully!`);
            setStudents((prev) => prev.filter((s) => s.StudentID !== student.StudentID));
        } catch (error) {
            console.error("Error promoting student", error);
        }
    }; */
    const handlePromoteAll = async () => {
        if (students.length === 0) {
            alert("No students to promote!");
            return;
        }
    
        try {
            // Get student IDs from the current list
            const studentIDs = students.map(student => student.StudentID);
            const adminName = sessionStorage.getItem("adminName"); // Retrieve admin name from session storage

            // Send API request to check fee balance
            const response = await fetch(`${BASE_URL}/api/checkFeeBalance`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ studentIDs }),
            });
    
            const result = await response.json();
    
            if (result.error) {
                alert("Error checking fee balance: " + result.error);
                return;
            }
    
            // Separate students with and without balance
            const studentsWithBalance = result.feeDetails.filter(student => Number(student.balance) > 0);
            const studentsWithoutBalance = result.feeDetails.filter(student =>  Number(student.balance) === 0);
            //console.log("Students with balance:", studentsWithBalance);
            //console.log("Students without balance:", studentsWithoutBalance);
            // Show alert for students with fee balance
            if (studentsWithBalance.length > 0) {
                let message = "The following students have outstanding fees:\n";
                studentsWithBalance.forEach(student => {
                    message += `${student.StudentName}: ₹${student.balance}\n`;
                });
                alert(message);
            }
    
            // Promote students with zero balance
            if (studentsWithoutBalance.length > 0) {
                const promoteResponse = await fetch(`${BASE_URL}/api/promoteStudents`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ studentIDs: studentsWithoutBalance.map(s => s.StudentID),adminName }),
                })
                .catch(err => console.error("Fetch error:", err));
                const promoteResult = await promoteResponse.json();
                if (promoteResult.success) {
                    alert("Successfully promoted eligible students!");
                } else {
                    alert("Error promoting students: " + promoteResult.error);
                }
            }
        }catch (error) {
            console.error("Error during promotion:", error);
            alert("An error occurred while promoting students.");
        }
    };
    return (
        <Container maxWidth="lg">
              <Typography variant="h4" sx={{ marginBottom: 2, textAlign: "center", fontWeight: "bold", color: "#1976d2" }}>
              Promote
             </Typography>
           {/*  {alertMessage && <Alert severity="warning">{alertMessage}</Alert>} */}
            {/* Filters Section */}
                 <Grid container spacing={2}>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Course"
                       value={selectedCourse}
                       onChange={(e) => setSelectedCourse(e.target.value)}
                       fullWidth
                     >
                       {courses.map((course) => (
                         <MenuItem key={course.CourseID} value={course.CourseID}>
                           {course.CourseName}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Academic Year"
                       value={selectedYear}
                       onChange={(e) => setSelectedYear(e.target.value)}
                       fullWidth
                       disabled={!selectedCourse}
                     >
                       {academicYears.map((year) => (
                         <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                           {year.AcademicYearName}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Class"
                       value={selectedClass}
                       onChange={(e) => setSelectedClass(e.target.value)}
                       fullWidth
                       disabled={!selectedCourse}
                     >
                       {classes.map((cls) => (
                         <MenuItem key={cls.ClassID} value={cls.ClassID}>
                           {cls.ClassName}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                 </Grid>
                   <Grid container spacing={2} sx={{ marginTop: 2 }}>
                         <Grid item xs={9}>
                           <TextField label="Search Student" value={searchText} onChange={(e) => setSearchText(e.target.value)} fullWidth />
                         </Grid>
                         <Grid item xs={3}>
            <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button> </Grid>
                  </Grid>
            {students.length > 0 && (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Student Name</TableCell>
                                <TableCell>Student ID</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {students.map((student) => (
                                <TableRow key={student.StudentID}>
                                    <TableCell>{student.StudentName}</TableCell>
                                    <TableCell>{student.StudentID}</TableCell>
                                    <TableCell>{student.CourseName}</TableCell>
                                <TableCell>{student.AcademicYearName}</TableCell>
                                <TableCell>{student.ClassName}</TableCell>
                                    {/* <TableCell>
                                        <Button variant="contained" color="secondary" onClick={() => handlePromote(student)}>
                                            Promote
                                        </Button>
                                    </TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                     
            )}
             {/* Promote All Button */}
        {students.length > 0 && (
            <Grid container justifyContent="center" sx={{ marginTop: 2 }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handlePromoteAll}
                    /* startIcon={<UpgradeIcon />} */
                >
                    Promote All
                </Button>
            </Grid>
        )}
             {/* Pagination */}
             <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        sx={{ marginTop: 2, display: "flex", justifyContent: "center" }}
                      />
        </Container>
    );
};

export default PromotePage;